import React, { useState, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  Backdrop,
  LogoLoader,
  useFormHandler,
  NewTab,
} from "../../../../components";
import {
  indusriesMonsterOptions,
  LanguageskillsMonster,
  MonsterEducationLevel,
  MonsterRadiusOptions,
  optionsMonsterPostFrom,
  optionsMonsterTo,
  statesArrayOptionMonster,
  careerLevelMonster,
  ProfessionalLevelMonsterOptions,
  salaryTypeMonsterOptions,
} from "../../../../assets/data/enumData";
import RecentHistory from "../CommonJobBoardTabs/RecentHistory";
import SavedHistory from "../CommonJobBoardTabs/SavedHistory";
import { useDispatch, useSelector } from "react-redux";
import SearchResults from "../SearchResults";
import { showToast } from "../../../../components";
import { getMonsterApplicantsDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import {
  getCountries,
  getLocations,
} from "../../../../redux/slices/internalDbES/internalDbESApi";
import { normalizeQuotes } from "../../../../utils/common";
const ClassicSearch = ({ loadMonster, saveAccessId, setShowButtons }) => {
  setShowButtons(true);
  const dispatch = useDispatch();
  const [searchApplicant, setSearchApplicant] = useState(false);
  // const [reload,setReload]=useState(false)
  const [advancedSearch, setAdvancedSearch] = useState(false);
  // const [accountsModal, setAccountsModal] = useState(true);
  // const [updatedAction, setUpdatedAction] = useState();
  const { loading } = useSelector((state) => state.internalDbES);
  const [requestBody, setRequestBody] = useState(null);
  const { user } = useSelector((state) => state.auth);
  //   const classicMonsterData = useSelector(
  //   (state) => state?.bdmjobs?.jobBoards?.monster?.classic?.data ?? []
  // );
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState({});
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [locationTypingValue, setLocationTypingValue] = useState("");
  const [locations, setLocations] = useState([]);
  const [fallbackpayloadLoc, setfallbackpayloadLoc] = useState("");
  const [rpcr, setrpcr] = useState("");

  const safeDecode = (v) => {
    try {
      return typeof v === "string" ? decodeURIComponent(v) : v;
    } catch {
      return v;
    }
  };
  const handleSelect = ({ title, filterTerms = {} }) => {
    setLocationTypingValue(
      safeDecode(filterTerms?.zipcode)?.replace(/-\d+$/, ""),
    );
    const radius = filterTerms?.rpcr ?? "";
    // console.log(filterTerms?.rpcr)
    setrpcr(filterTerms?.rpcr);
    const parts = String(radius)
      .split("-")
      .map((p) => p.trim());
    const radiusDist = parts[1] || 30;

    const langData = filterTerms?.Lskill ?? "";
    const langParts = String(langData)
      .split("-")
      .map((p) => p.trim());
    const langProfy = langParts[0] || "";
    const langProfyLevl = langParts[1] || "";

    const includeDetails = [];
    if (filterTerms?.twlid === 1 || filterTerms?.twlid === "1") {
      includeDetails.push("1");
    }
    if (filterTerms?.wa === 163 || filterTerms?.wa === "163") {
      includeDetails.push("2");
    }
    setfallbackpayloadLoc(filterTerms?.zipcode);
    const mapped = {
      jobTitleOrKeyword: filterTerms?.jobTitleOrKeyword ?? "",
      from: filterTerms?.mdateminage ?? 0,
      to: filterTerms?.mdatemaxage ?? 43200,
      radioLocation: filterTerms?.selectWithRadius ?? 1,
      country: filterTerms?.country === 840 ? "United States" : "Canada",
      state: filterTerms?.rlid
        ? typeof filterTerms.rlid === "string"
          ? filterTerms.rlid.split("+")
          : Array.isArray(filterTerms.rlid)
            ? filterTerms.rlid
            : [String(filterTerms.rlid)]
        : [],
      distance: radiusDist ?? "",
      zipCode: filterTerms?.zipcode ?? "",
      includeDetails: includeDetails,
      mostRecentEmployer: filterTerms?.qrcn ?? "",
      mostRecentJobTitle: filterTerms?.qrjt ?? "",
      mostRecentDescription: filterTerms?.qrjd ?? "",
      schoolAttended: filterTerms?.qsn ?? "",
      minimum: filterTerms?.tnsalmin ?? "",
      maximum: filterTerms?.tnsalmax ?? "",
      perYear: filterTerms?.tsalcur ?? "",
      showResumes:
        filterTerms?.tsni === 1
          ? "Show Resumes without a desired salary"
          : "",
      jobSeekerProfile: filterTerms?.edulv ?? 1,
      moreProfileOptions: filterTerms?.clv
        ? String(filterTerms.clv)
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean)
        : [],
      languageProficiency: langProfy ?? "",
      proficiencyLevel: langProfyLevl ?? "",
      industries: (filterTerms?.twindus && String(filterTerms?.twindus)) ?? "",
      jobStatus: (() => {
        const statuses = [];
        if (filterTerms?.tjtft === 1) statuses.push("Full-Time");
        if (filterTerms?.tjtpt === 1) statuses.push("Part-Time");
        if (filterTerms?.tjtpd === 1) statuses.push("Contract");

        return statuses;
      })(),
      jobType: (() => {
        const statuses = [];
        if (filterTerms?.tjtp === 1) statuses.push("Employee");
        if (filterTerms?.tjti === 1) statuses.push("Intern");
        if (filterTerms?.tjttc === 1)
          statuses.push("Temporary/Contract/Permanent or Full Time");
        if (filterTerms?.tjts === 1) statuses.push("Seasonal");
        return statuses;
      })(),
    };

    setFormData({
      ...initialFormData,
      ...mapped,
    });
    setSelectedTitle(title);
  };

  // useEffect(() => {
  //   setAccountsModal(accountsModal);
  // }, [accountsModal]);

  const initialFormData = {
    jobTitleOrKeyword: "",
    from: 0,
    to: 43200,
    radioLocation: 1,
    country: "United States",
    state: [],
    distance: 30,
    zipCode: "",
    includeDetails: [],
    mostRecentEmployer: "",
    mostRecentJobTitle: "",
    mostRecentDescription: "",
    schoolAttended: "",
    minimum: "",
    maximum: "",
    perYear: "",
    showResumes: [],
    jobSeekerProfile: "",
    moreProfileOptions: "",
    languageProficiency: "",
    proficiencyLevel: "",
    industries: "",
    jobStatus: [],
    jobType: [],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      jobTitleOrKeyword: {
        type: "text",
        required: true,
      },
    });

  // const cleanData = (formData) => {
  //   const flatten = (obj, prefix = '', result = {}) => {
  //     if (Array.isArray(obj)) {
  //       // ✅ Instead of breaking into indexed keys, preserve array
  //       result[prefix] = obj;
  //     } else if (typeof obj === 'object' && obj !== null) {
  //       for (const key in obj) {
  //         if (Object.hasOwn(obj, key)) {
  //           const value = obj[key];
  //           const newKey = prefix ? `${prefix}.${key}` : key;
  //           flatten(value, newKey, result);
  //         }
  //       }
  //     } else {
  //       result[prefix] = obj;
  //     }
  //     return result;
  //   };

  //   const flattened = flatten(formData);

  //   const cleanFormData = {};
  //   for (const key in flattened) {
  //     const value = flattened[key];

  //     // keep arrays intact; skip only if it's empty
  //     if (
  //       value !== '' &&
  //       value !== null &&
  //       value !== undefined &&
  //       !(Array.isArray(value) && value.length === 0)
  //     ) {
  //       cleanFormData[key] = value;
  //     }
  //   }

  //   return cleanFormData;
  // }

  // const updateStateAction = (state) => {
  //   const updatedState = {
  //     payload: {
  //       lim: state.payload.lim,
  //       page: state.payload.page,
  //       body: {
  //         ...cleanData(formData),
  //         skills: formData.skills?.join(", ") || "",
  //       },
  //       onSuccess: () => {
  //         console.log("Monster Classic pagination updated successfully");
  //       },
  //     },
  //   };
  //   setUpdatedAction(updatedState);

  //   // Dispatch the saga again with updated pagination info
  //   dispatch(fetchMonsterClassicStart(updatedState.payload));
  // };

  const buildBooleanSearch = (include = "") => {
    const clean = (text) =>
      text
        .split(/[\s,]+/) // split by any space or comma
        .map((t) => t.trim())
        .filter(Boolean);
    // .filter((t) => !["and", "or", "not"].includes(t.toLowerCase())); // remove logical words if typed manually

    const includeKeywords = clean(include);
    const includePart = includeKeywords.join(" ");

    return includePart || "";
  };

  const handleMonsterSearch = ({ title, filterTerms }) => {
    handleSearch(title, filterTerms);
    setSelectedTitle("");
  };

  const handleSearch = async (title, filterTerms) => {
    let keyword; //= formData.jobTitleOrKeyword || selectedTitle || title;
 // console.log("hadle search ", title);

    if (title) {
      keyword = title;
    } else {
      keyword = formData.jobTitleOrKeyword || selectedTitle || title;
    }

    if (!keyword) {
      showToast("Job Title or keyword is required!", "error");
      return;
    }
    const openParen = (keyword.match(/\(/g) || []).length;
    const closeParen = (keyword.match(/\)/g) || []).length;

    if (openParen !== closeParen) {
      showToast("Invalid keyword syntax: missing ')'.", "error", 2000);
      return;
    }

    // check unbalanced double quotes
    const quotes = (keyword.match(/"/g) || []).length;

    if (quotes % 2 !== 0) {
      showToast('Invalid keyword syntax: missing closing "', "error", 2000);
      return;
    }

    const booleanQuery = buildBooleanSearch(keyword);
    const [state, city, zipCode] = locationTypingValue.split(",");

    const isRadiusSearch = Number(formData.radioLocation) === 1;
    const isStateSearch = Number(formData.radioLocation) === 2;

    // console.log("formData.showResumes",formData.showResumes);
    const newRequestBody = {
      accessId: saveAccessId,
      searchType: "classic",
      payload: {
        query: {
          q: booleanQuery,
          // radius: formData.distance || 30,
          mdateminage: formData.from || 0,
          mdatemaxage: formData.to || 43200,
          country: Number(selectedCountryCode) || "US",
          // zipcode: zipCode || fallbackpayloadLoc || "",
          sort: "rank,distance,mdate",
          selectWithRadius: formData?.radioLocation || 1,
          // rlid: formData.state?.length > 0 ? formData.state.join("+") : "",
          // rpcr:
          //   zipCode && formData.distance
          //     ? `${zipCode}-${formData.distance}`
          //     : rpcr,

          radius: isRadiusSearch ? formData.distance || 30 : "",
          zipcode: isRadiusSearch ? zipCode || fallbackpayloadLoc || "" : "",
          rpcr: isRadiusSearch
            ? zipCode && formData.distance
              ? `${zipCode}-${formData.distance}`
              : rpcr
            : "",

          rlid:
            isStateSearch && formData.state?.length
              ? formData.state.join("+")
              : "",

          twlid: formData.includeDetails?.includes("1") ? 1 : "",
          wa: formData.includeDetails?.includes("2") ? 163 : "",
          qrcn: formData.mostRecentEmployer || "",
          qrjt: formData.mostRecentJobTitle || "",
          qrjd: formData.mostRecentDescription || "",
          qsn: formData.schoolAttended || "",
          // tsni: formData.showResumes
          //     ? 1
          //     : "",  
          tsni:
            formData.maximum || formData.minimum
              ? 0
              : (typeof formData.showResumes === "string" &&
                    formData.showResumes.trim() !== "") ||
                  (Array.isArray(formData.showResumes) &&
                    formData.showResumes.length > 0)
                ? 1
                : "",
          tnsalmin: formData.minimum || "",
          tnsalmax: formData.maximum || "",
          tsaltyp: formData.perYear || "1",
          tsalcur: formData.minimum || formData.maximum ? 1 : "",
          // clv: formData.moreProfileOptions || [],
          clv: Array.isArray(formData.moreProfileOptions)
            ? formData.moreProfileOptions.join(",")
            : [],
          edulv: formData.jobSeekerProfile || "",
          // Job Status
          tjtft: formData.jobStatus?.includes("Full-Time") ? 1 : "",
          tjtpt: formData.jobStatus?.includes("Part-Time") ? 1 : "",
          tjtpd: formData.jobStatus?.includes("Contract") ? 1 : "",
          // Job Type
          tjtp: formData.jobType?.includes("Employee") ? 1 : "",
          tjti: formData.jobType?.includes("Intern") ? 1 : "",
          tjttc: formData.jobType?.includes(
            "Temporary/Contract/Permanent or Full Time",
          )
            ? 1
            : "",
          tjts: formData.jobType?.includes("Seasonal") ? 1 : "",
          Lskill:
            formData.languageProficiency && formData.proficiencyLevel
              ? `${formData.languageProficiency}-${formData.proficiencyLevel}`
              : "",

          twindus: formData.industries || "",
          ...filterTerms,
        },
        page: 1,
        lim: 25,
        source: 3, // for classic
        addedBy: user?.data?.uiid,
      },
    };
    // console.log("search", newRequestBody);
    try {
      setRequestBody(newRequestBody);
      dispatch(
        getMonsterApplicantsDataStart({
          ...newRequestBody,
          onSuccess: () => {
            setSearchApplicant((prev) => !prev);
            setFormData(initialFormData);
            setLocationTypingValue("");
            setSelectedTitle("");
            setrpcr("");
          },
        }),
      );
    } catch (error) {
      console.error("Monster search error:", error);
    } finally {
    }

    // dispatch(fetchMonsterClassicStart({
    //   body: requestBody,

    //   onSuccess: (data) => {
    //     console.log("Monster Classic Data:", data);
    //     handleSearchApplicantCallback();
    //   },
    // }));
    // dispatch(fetchMonsterClassicStart(requestBody));
    // setLoading(false);
    // console.log("classicMonsterData",classicMonsterData)
  };

  const monsterMenus = [
    {
      title: "Recent History",
      page: (
        <RecentHistory
          board="monster"
          subBoard="classic"
          onSelect={handleSelect}
          onClick={handleMonsterSearch}
        />
      ),
      type: "main",
    },
    {
      title: "Saved History",
      page: (
        <SavedHistory
          board="monster"
          subBoard="classic"
          onSelect={handleSelect}
          onClick={handleMonsterSearch}
        />
      ),
      type: "main",
    },
  ];

  const onSuccess = () => {
    setSearchApplicant((prev) => !prev);
  };

  // useEffect(() => {
  //     if (!locationTypingValue) return;
  //     const [city, state, zip] = locationTypingValue.split(",");
  //     if (city && state) return;

  //     const delay = setTimeout(async () => {
  //       setLocations([])
  //       const response = await getLocations({ locationValue: locationTypingValue, country: selectedCountry?._id });
  //       if (response?.success) {
  //         const locationData = response?.data?.data
  //           .map((item) => {
  //             const name = item.name ?? "";
  //             const state = item.stateName ?? "";
  //             const zip = item.zipCode ?? "";

  //             return `${name},${state},${zip}`.trim();
  //           });
  //         setLocations(locationData)
  //       }
  //     }, 0);

  //     return () => clearTimeout(delay);
  //   }, [locationTypingValue, formData?.country]);

  //   useEffect(() => {
  //     if (!formData?.country) return;

  //     const delay = setTimeout(async () => {
  //       const response = await getCountries({ name: formData?.country });
  //       // console.log("response",response)
  //       const countries = response.data.data
  //       const desiredCountry = countries[0];

  //       setSelectedCountry(desiredCountry);
  //       setSelectedCountryCode(desiredCountry?.numericCode)
  //       setLocationTypingValue("")
  //     }, 0);

  //     return () => clearTimeout(delay);
  //   }, [formData?.country]);

  useEffect(() => {
    if (!locationTypingValue) return;
    const [city, state, zip] = (locationTypingValue ?? "").split(",");
    if (city && state) return;

    const delay = setTimeout(async () => {
      setLocations([]);
      const response = await getLocations({
        locationValue: locationTypingValue,
        country: selectedCountryId?._id,
        limit: 500,
      });
      if (response?.success) {
        const uniqueStates = [
          ...new Set(
            (response?.data?.data || []).map((item) => item.stateName),
          ),
        ];
        const locationData = response?.data?.data.flatMap((item) => {
          const name = item.name ?? "";
          const state = item.stateName ?? "";
          if (Array.isArray(item.zipCode)) {
            return item.zipCode.map((zc) => `${name},${state},${zc}`);
          }
          return [`${name},${state},${item.zipCode ?? ""}`];
        });
        //  setLocations([...uniqueStates,...locationData ])
        const search = locationTypingValue.toLowerCase();
        // const statesStartsWith = uniqueStates.filter((item) =>
        //   item.toLowerCase().startsWith(search)
        // );
        // const statesContains = uniqueStates.filter(
        //   (item) =>
        //     item.toLowerCase().includes(search) &&
        //     !item.toLowerCase().startsWith(search)
        // );
        const locationsStartsWith = locationData.filter((item) =>
          item.toLowerCase().startsWith(search),
        );
        const locationsContains = locationData.filter(
          (item) =>
            item.toLowerCase().includes(search) &&
            !item.toLowerCase().startsWith(search),
        );
        // statesStartsWith.sort((a, b) => a.localeCompare(b));
        // statesContains.sort((a, b) => a.localeCompare(b));
        locationsStartsWith.sort((a, b) => a.localeCompare(b));
        locationsContains.sort((a, b) => a.localeCompare(b));
        setLocations([
          // ...statesStartsWith,
          ...locationsStartsWith,
          // ...statesContains,
          ...locationsContains,
        ]);
      }
    }, 0);

    return () => clearTimeout(delay);
  }, [locationTypingValue, formData?.country]);

  useEffect(() => {
    if (!formData?.country) return;

    const delay = setTimeout(async () => {
      const response = await getCountries({ name: formData?.country });
      const countries = response?.data?.data;
      const desiredCountryId = countries[0];
      setSelectedCountryId(desiredCountryId);
      setSelectedCountryCode(desiredCountryId?.numericCode);
      setLocationTypingValue("");
    }, 0);

    return () => clearTimeout(delay);
  }, [formData?.country]);

  const allValues = careerLevelMonster.map((o) => o.value);
  const isAllSelected = formData.moreProfileOptions.length === allValues.length;

  // Add dynamic Select/Deselect All option
  const careerLevelOptionsUI = [
    { label: isAllSelected ? "Deselect All" : "Select All", value: "__ALL__" },
    ...careerLevelMonster,
  ];

  const handleCareerLevelChange = (selectedValues = []) => {
    if (selectedValues.includes("__ALL__")) {
      // Toggle all / deselect all
      handleChange("moreProfileOptions", isAllSelected ? [] : allValues);
      return;
    }

    handleChange("moreProfileOptions", selectedValues);
  };

  const industryAllValues = indusriesMonsterOptions.map((o) => o.value);

  const isIndustryAllSelected =
    (formData?.industries || []).length === industryAllValues.length;

  const industriesOptionsUI = [
    {
      label: isIndustryAllSelected ? "Deselect All" : "Select All",
      value: "__ALL__",
    },
    ...indusriesMonsterOptions,
  ];

  const handleIndustriesChange = (selectedValues = []) => {
    if (selectedValues.includes("__ALL__")) {
      handleChange(
        "industries",
        isIndustryAllSelected ? [] : industryAllValues,
      );
      return;
    }

    handleChange("industries", selectedValues);
  };

  return !searchApplicant ? (
    <div>
      <div className="p-3 m-2 flex flex-1 md:flex-col lg:flex-row overflow-hidden">
        <div className=" flex-1 m-4 inner-section rounded-md overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-1 m-5 ">
            <FormFieldSet
              noTitle
              placeholder="Job Title or Keyword"
              value={formData?.jobTitleOrKeyword || selectedTitle}
              onChange={(value) => {
                handleChange("jobTitleOrKeyword", normalizeQuotes(value));
                setSelectedTitle("");
              }}
              error={errors?.jobTitleOrKeyword}
              shadow={true}
            />
          </div>
          <div className="grid grid-cols-2 m-5 gap-4">
            <FormFieldSet
              title="Resume Posted"
              placeholder="From"
              options={optionsMonsterPostFrom}
              type="select"
              value={formData?.from}
              onChange={(value) => handleChange("from", value)}
              error={errors?.from}
              shadow={true}
            />
            <FormFieldSet
              title=" "
              placeholder="To"
              options={optionsMonsterTo}
              type="select"
              value={formData?.to}
              onChange={(value) => handleChange("to", value)}
              error={errors?.to}
              shadow={true}
            />
          </div>
          <div className="grid grid-cols-1 m-5 gap-4">
            <FormFieldSet
              type="radio"
              size="md"
              title="Location (Choose any 1 option):"
              placeholder="Enter Zip Code"
              options={[
                {
                  label: "Search within selected ZipCode",
                  value: 1,
                },
                {
                  label: "Search within selected locations",
                  value: 2,
                },
              ]}
              value={formData?.radioLocation}
              onChange={(event) =>
                handleChange("radioLocation", event.target.value)
              }
              error={errors.radioLocation}
            />
          </div>
          <div className="grid grid-cols-2 m-5 gap-4">
            <div className="col-span-2">
              <FormFieldSet
                // type="select"
                type="countriesUsAndCanada"
                noTitle
                // options={countryMonsterOptions}
                placeholder="Country"
                value={formData?.country}
                onChange={(value) => handleChange("country", value.value)}
                error={errors?.country}
                shadow={true}
              />
            </div>
          </div>
          {formData.radioLocation == 1 ? (
            <div className="grid grid-cols-2 m-5 gap-4">
              <FormFieldSet
                type="select"
                noTitle
                options={MonsterRadiusOptions}
                placeholder="30 miles away"
                value={formData?.distance}
                onChange={(value) => handleChange("distance", value)}
                error={errors?.distance}
                shadow={true}
              />
              <FormFieldSet
                noTitle
                // type="text"
                placeholder="Zip Code"
                // value={formData?.zipCode}
                value={locationTypingValue}
                // onChange={(value) => handleChange("zipCode", value)}
                onChange={(value) => {
                  setLocationTypingValue(value);
                  handleChange("zipCode", value);
                  setLocations([]);
                  if (!value || value.trim() === "") {
                    setfallbackpayloadLoc("");
                    setrpcr("");
                  }
                }}
                error={errors?.zipCode}
                shadow={true}
                suggestionsList={locations}
              />
            </div>
          ) : formData.radioLocation == 2 ? (
            <div className="grid grid-cols-2 m-5 gap-4">
              <div className="col-span-2">
                <FormFieldSet
                  type="select"
                  noTitle
                  multiple={true}
                  showSearch
                  options={statesArrayOptionMonster}
                  placeholder="Select State"
                  value={formData?.state}
                  onChange={(value) => handleChange("state", value)}
                  error={errors.state}
                  // parentValue={{ country: formData?.country?.value }}
                  disabled={!formData?.country}
                  shadow={true}
                />
              </div>
            </div>
          ) : null}

          <div className="grid grid-cols-1 lg:grid-cols-1 m-5 gap-1">
            <FormFieldSet
              type="checkbox"
              size="md"
              noTitle
              placeholder="Select"
              options={[
                {
                  label:
                    "Include Job Seekers Employable in Any of the Selected Locations",
                  value: "1",
                },
                {
                  label:
                    "Include Job Seekers Authorized to Work for any Employer in Any of the Selected Locations.",
                  value: "2",
                },
              ]}
              multiple
              values={formData?.includeDetails}
              onChange={(value) => handleChange("includeDetails", value)}
              error={errors?.includeDetails}
            />
          </div>

          <div className="flex justify-end">
            {advancedSearch ? (
              <Button
                variant="text"
                title="Hide Advanced Search"
                color="info"
                className="italic underline underline-offset-2 decoration-2"
                onClick={() => setAdvancedSearch((prev) => !prev)}
              />
            ) : (
              <Button
                variant="text"
                title="Advanced Search"
                color="info"
                className="italic underline underline-offset-2 decoration-2"
                onClick={() => setAdvancedSearch((prev) => !prev)}
              />
            )}
          </div>
          {advancedSearch && (
            <>
              <div className="mx-2 my-3 gap-4">
                <h6 className="my-1">Resume Details:</h6>
                <p className="my-1 text-gray-400 text-sm">
                  Enter keywords to Search Areas of Job Seekers Resume
                </p>
              </div>
              <div className="grid grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 mx-2 my-2 gap-3">
                <FormFieldSet
                  placeholder="Most Recent Employer"
                  title="Most Recent Employer"
                  value={formData?.mostRecentEmployer}
                  onChange={(value) =>
                    handleChange("mostRecentEmployer", value)
                  }
                  error={errors?.mostRecentEmployer}
                  shadow={true}
                />
                <FormFieldSet
                  placeholder="Most Recent Job Title"
                  title="Most Recent Job Title"
                  value={formData?.mostRecentJobTitle}
                  onChange={(value) =>
                    handleChange("mostRecentJobTitle", value)
                  }
                  error={errors?.mostRecentJobTitle}
                  shadow={true}
                />
                <FormFieldSet
                  placeholder="Most Recent Description"
                  title="Most Recent Description"
                  value={formData?.mostRecentDescription}
                  onChange={(value) =>
                    handleChange("mostRecentDescription", value)
                  }
                  error={errors?.mostRecentDescription}
                  shadow={true}
                />
                <FormFieldSet
                  placeholder="School Attended"
                  title="School Attended"
                  value={formData?.schoolAttended}
                  onChange={(value) => handleChange("schoolAttended", value)}
                  error={errors?.schoolAttended}
                  shadow={true}
                />
                <FormFieldSet
                  placeholder="Minimum"
                  title="Desired Salary"
                  value={formData?.minimum}
                  onChange={(value) => handleChange("minimum", value)}
                  error={errors?.minimum}
                  shadow={true}
                />
                <FormFieldSet
                  placeholder="Maximum"
                  title=" "
                  value={formData?.maximum}
                  onChange={(value) => handleChange("maximum", value)}
                  error={errors?.maximum}
                  shadow={true}
                />
                <div className="flex flex-col">
                  <FormFieldSet
                    placeholder="Per Year"
                    type="select"
                    title="Salary Type"
                    options={salaryTypeMonsterOptions}
                    value={formData?.perYear}
                    onChange={(value) => handleChange("perYear", value)}
                    error={errors?.perYear}
                    shadow={true}
                  />
                  <FormFieldSet
                    type="checkbox"
                    size="sm"
                    noTitle
                    options={[
                      {
                        label: "Show Resumes without a desired salary",
                        value: "Show Resumes without a desired salary",
                      },
                    ]}
                    values={formData?.showResumes}
                    onChange={(value) => handleChange("showResumes", value)}
                    error={errors?.showResumes}
                  />
                </div>
                <div className="flex flex-col">
                  {/* <FormFieldSet
                      placeholder="Most recent Job Title"
                      title="Job Seeker Profile"
                      value={formData.jobSeekerProfile}
                      onChange={(value) =>
                        handleChange("jobSeekerProfile", value)
                      }
                      error={errors.jobSeekerProfile}
                    /> */}
                  <FormFieldSet
                    type="select"
                    placeholder="Most recent Job Title"
                    title="Job Seeker Profile"
                    options={MonsterEducationLevel}
                    value={formData?.jobSeekerProfile}
                    onChange={(value) =>
                      handleChange("jobSeekerProfile", value)
                    }
                    error={errors?.jobSeekerProfile}
                    shadow={true}
                  />
                  <p className="text-sm mt-2">
                    <span className="text-red-400">*</span> Show Jobseekers with
                    Selected Education level or higher
                  </p>
                </div>
                <div className="flex flex-col">
                  <FormFieldSet
                    type="select"
                    placeholder="Career Level"
                    title="More Profile Options"
                    options={careerLevelOptionsUI}
                    value={formData?.moreProfileOptions}
                    // onChange={(value) =>
                    //   handleChange("moreProfileOptions", value)
                    // }
                    onChange={handleCareerLevelChange}
                    error={errors?.moreProfileOptions}
                    shadow={true}
                    multiple={true}
                  />
                  <p className="text-sm mt-2">
                    <span className="text-red-400">*</span> only show Jobseekers
                    with the selected Career level
                  </p>
                </div>
                <FormFieldSet
                  type="select"
                  placeholder="Select a Language"
                  title="Language Proficiency"
                  options={LanguageskillsMonster}
                  value={formData?.languageProficiency}
                  onChange={(value) =>
                    handleChange("languageProficiency", value)
                  }
                  error={errors?.languageProficiency}
                  shadow={true}
                  showSearch
                />
                <FormFieldSet
                  type="select"
                  placeholder="Beginner"
                  options={ProfessionalLevelMonsterOptions}
                  title="Proficiency Level"
                  value={formData?.proficiencyLevel}
                  onChange={(value) => handleChange("proficiencyLevel", value)}
                  error={errors?.proficiencyLevel}
                  shadow={true}
                />
                <FormFieldSet
                  type="select"
                  placeholder="Select"
                  title="Industries"
                  options={industriesOptionsUI}
                  value={formData?.industries || []}
                  onChange={handleIndustriesChange}
                  error={errors?.industries}
                  shadow={true}
                  // multiple={true}
                  showSearch
                />
              </div>
              <div className="grid grid-cols-1 gap-6">
                <div className="flex flex-col gap-1">
                  <FormFieldSet
                    type="checkbox"
                    size="md"
                    title="Job Status"
                    multiple={true}
                    options={[
                      {
                        label: "Full-Time",
                        value: "Full-Time",
                      },
                      {
                        label: "Part-Time",
                        value: "Part-Time",
                      },
                      {
                        label: "Contract",
                        value: "Contract",
                      },
                    ]}
                    values={formData?.jobStatus}
                    onChange={(value) => handleChange("jobStatus", value)}
                    error={errors?.jobStatus}
                  />
                  <p className="text-sm">
                    <span className="text-red-400">*</span> only show Jobseekers
                    interested in the selected job status
                  </p>
                </div>

                <div className="flex flex-col gap-1">
                  <FormFieldSet
                    type="checkbox"
                    size="md"
                    title="Job Type"
                    multiple={true}
                    options={[
                      {
                        label: "Employee",
                        value: "Employee",
                      },
                      {
                        label: "Intern",
                        value: "Intern",
                      },
                      {
                        label: "Temporary/Contract/Permanent or Full Time",
                        value: "Temporary/Contract/Permanent or Full Time",
                      },
                      {
                        label: "Seasonal",
                        value: "Seasonal",
                      },
                    ]}
                    values={formData?.jobType}
                    onChange={(value) => handleChange("jobType", value)}
                    error={errors?.jobType}
                  />
                  <p className="text-sm">
                    <span className="text-red-400">*</span> only show Jobseekers
                    interested in the selected job type
                  </p>
                </div>
              </div>
            </>
          )}
          <div className="flex gap-3 justify-end mx-10 my-8">
            <Button
              title={"Reset"}
              size="sm"
              variant="outlined"
              onClick={() => {
                setFormData(initialFormData);
                setSelectedTitle("");
              }}
            />
            <Button
              disabled={!loadMonster && !saveAccessId}
              title={"Search"}
              size="sm"
              onClick={() => handleSearch()}
            />
          </div>
        </div>
        <div className="flex flex-1 flex-col mx-2 overflow-y-auto">
          <p className="font-[600] mx-2">Strings History</p>
          <div className="flex flex-1 shadow m-2 p-3 overflow-y-auto rounded-md">
            <NewTab
              tabs={monsterMenus}
              color="gray"
              variant="text"
              activeVariant="text"
            />
          </div>
        </div>
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      {/* <AccountsModal
        isOpen={accountsModal}
        onClose={() => setAccountsModal(false)}
      /> */}
    </div>
  ) : (
    <div className="flex flex-1 flex-col overflow-hidden mt-2">
      <SearchResults
        source={3}
        query={requestBody}
        loading={loading}
        setSearchApplicant={setSearchApplicant}
        setShowButtons={setShowButtons}
      />
    </div>
  );
};

export default ClassicSearch;
